import { Drawer, Modal } from '@mantine/core'

import IntercomWrapper from '../IntercomWrapper'

import { ApplicantDrawerContextProvider } from './ApplicantDrawerContext'
import { ApplicantListContextProvider } from './ApplicantListContext'
import { CallDrawerContextProvider } from './CallDrawerContext'
import { CurrentCompanyContextProvider } from './CurrentCompanyContext'
import { CustomStepsContextProvider } from './CustomStepsContext'
import { EmailModalContextProvider } from './EmailModalContext'
import { EmploymentDetailsDrawerContextProvider } from './EmploymentDetailsDrawerContext'
import { ReadOnlyEmailModalContextProvider } from './ReadOnlyEmailModalContext'
import { RecruitersContextProvider } from './RecruitersContext'
import { TaskModalContextProvider } from './TaskModalContext'

const DashboardContexts = ({ children }) => {
  return (
    <IntercomWrapper>
      <RecruitersContextProvider>
        <CustomStepsContextProvider>
          <CurrentCompanyContextProvider>
            <Drawer.Stack>
              <Modal.Stack>
                <ApplicantDrawerContextProvider>
                  <CallDrawerContextProvider>
                    <EmploymentDetailsDrawerContextProvider>
                      <ApplicantListContextProvider>
                        <TaskModalContextProvider>
                          <EmailModalContextProvider>
                            <ReadOnlyEmailModalContextProvider>
                              {children}
                            </ReadOnlyEmailModalContextProvider>
                          </EmailModalContextProvider>
                        </TaskModalContextProvider>
                      </ApplicantListContextProvider>
                    </EmploymentDetailsDrawerContextProvider>
                  </CallDrawerContextProvider>
                </ApplicantDrawerContextProvider>
              </Modal.Stack>
            </Drawer.Stack>
          </CurrentCompanyContextProvider>
        </CustomStepsContextProvider>
      </RecruitersContextProvider>
    </IntercomWrapper>
  )
}

export default DashboardContexts
